// TODO - consider putting "change password", "change email", and "delete account"
// all as items under a gear icon ("account settings") on the menu
// (could do nested dialog options)

import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';
import KeyIcon from '@mui/icons-material/Key';
import LogoutIcon from '@mui/icons-material/Logout';

import SignOut from "src/components/Dashboard/Menu/SignOut"
import ChangePassword from "src/components/Forms/ChangePassword"
import ChangeEmail from "src/components/Forms/ChangeEmail"

// export const mainListItems = (
//     <React.Fragment>
//         <ListItemButton>
//             <ListItemIcon>
//                 <DashboardIcon />
//             </ListItemIcon>
//             <ListItemText primary="Dashboard" />
//         </ListItemButton>
//         <ListItemButton>
//             <ListItemIcon>
//                 <ShoppingCartIcon />
//             </ListItemIcon>
//             <ListItemText primary="Orders" />
//         </ListItemButton>
//         <ListItemButton>
//             <ListItemIcon>
//                 <PeopleIcon />
//             </ListItemIcon>
//             <ListItemText primary="Customers" />
//         </ListItemButton>
//         <ListItemButton>
//             <ListItemIcon>
//                 <BarChartIcon />
//             </ListItemIcon>
//             <ListItemText primary="Reports" />
//         </ListItemButton>
//         <ListItemButton>
//             <ListItemIcon>
//                 <LayersIcon />
//             </ListItemIcon>
//             <ListItemText primary="Integrations" />
//         </ListItemButton>
//     </React.Fragment>
// );

export const secondaryListItems = (
    <React.Fragment>
        <ListSubheader component="div" inset>
            User account
        </ListSubheader>

        <ChangeEmail />

        <ChangePassword />

        <SignOut />

    </React.Fragment>
);
